<div class="flex flex-row items-center space-x-2">
  <div class="flex flex-col">
    <app-profile-picture (click)="toggleShowAccountBubble()" [src]="appAuthService.profilePicture | async"
    class="w-10 h-10 cursor-pointer"></app-profile-picture>
  </div>
</div>

@if (showAccountBubble) {
  <div class="account-bubble">
    @if (appAuthService.currentUser | async; as user) {
      <span class="text-center font-bold text-xs mb-2">{{ user.userProfile.firstName }} {{ user.userProfile.lastName }}</span>
    }
    <a (click)="logout()" href="javascript:void(0)" class="flex space-x-1 items-center">
      <app-icon [icon]="icons.logoutVariant"></app-icon>
      <span>{{ 'Logout' | localizeText : 'Logout' }}</span>
    </a>
  </div>
}
